import adminRoutes from './adminRoutes/routesOnNav';
import mailRoutes from './mailRoutes/routesOnNav';
import authRoutes from './authRoutes/routesOnNav';
import performanceRoutes from './performanceRoutes/routesOnNav';
import topLevelRoutes from './topLevelRoutes/routesOnNav';
import { DEFAULT_ACCESS_CONTROL } from 'constants/common';
import { useSelector } from 'react-redux';
import acgRoutes from './acgRoutes/routesOnNav';

export const getBasePath = path =>
  path === '/' ? '/' : (path || '').split('/').filter(v => !!v)[0];

export const removeHiddenRoutes = routes =>
  (routes || []).filter(route => !route.hidden);

export const permissionBasedRouting = (routes, currentUser) => {
  const permissionControl = currentUser?.permissions || DEFAULT_ACCESS_CONTROL;
  routes.map(route => {
    if (!('def_hidden' in route)) route.def_hidden = route.hidden;
    if (!route.permission) return;
    route.hidden =
      route.def_hidden ||
      !(
        route.permission && permissionControl.join().includes(route.permission)
      );
  });
  return routes;
};

function getGroupedChildRoutes(childRoutes, user) {
  const groupedChildRoutes = {};
  childRoutes.forEach(routes => {
    const { path } = routes[0];
    const basePath = getBasePath(path);
    const permissionBasedRoutes = permissionBasedRouting(routes, user);
    groupedChildRoutes[basePath] = removeHiddenRoutes(permissionBasedRoutes);
  });
  return groupedChildRoutes;
}

function getAllRoutes({ topRoutes, childRoutes, user }) {
  const groupedChildRoutes = getGroupedChildRoutes(childRoutes, user);
  const permissionBasedRoutes = permissionBasedRouting(topRoutes, user);
  const visibleTopRoutes = removeHiddenRoutes(permissionBasedRoutes);
  return visibleTopRoutes.map(topLevelRoute => {
    const { path } = topLevelRoute;
    const basePath = getBasePath(path);
    const group = groupedChildRoutes[basePath];
    return group ? { ...topLevelRoute, group } : topLevelRoute;
  });
}

const childRoutes = [
  adminRoutes,
  mailRoutes,
  authRoutes,
  performanceRoutes,
  acgRoutes,
];

export function useVisibleRoutes() {
  const user = useSelector(state => state.auth.user);
  return getAllRoutes({ topRoutes: topLevelRoutes, childRoutes, user });
}

export default getAllRoutes({ topRoutes: topLevelRoutes, childRoutes });
